// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1__d09ad9b97e38852351f9","cls2":"Header-cls2__e07045b97f5f9ead6c96 Header-cls1__d09ad9b97e38852351f9"};